import React, { useState } from 'react';
import { FaHourglassHalf } from "react-icons/fa6";
import { useDropzone } from 'react-dropzone';
import { save } from '../../services/stacks';
import './style.scss';
import { isUserSignedIn } from '../../services/auth';
import { Button } from '@mui/material';
import { derupt_avatar } from '../../lib/constants';

const AvatarUpload = ({
    setUrl,
    setErrorMsg,
    setOpenSnackBar
}) => {
    const [isSaving, setIsSaving] = useState(false);

    const onDrop = (acceptedFiles, rejectedFiles) => {
        setIsSaving(true);
        if (rejectedFiles.length > 0) {
            setErrorMsg({
                msg: `Error: Banner should be a PNG file under 2MB`,
                reason: 'error',
            });
            setIsSaving(false);
            setOpenSnackBar(true);
            return;
        }

        const file = acceptedFiles[0];
        const image = new Image();
        image.onload = async () => {
            if (image.width === 284 && image.height === 284) {
                const content = file;
                console.log({ derupt_avatar });
                save({ content, fileName: derupt_avatar }, { encrypt: false }).then(({ result: url, success }) => {
                    if (success) {
                        setUrl(url);
                        setErrorMsg({ msg: `Image uploaded successfully`, reason: 'success' });
                    } else {
                        setErrorMsg({ msg: `Error:  Image upload failed`, reason: 'error' });
                    }
                    if (rejectedFiles.length > 0) {
                        setErrorMsg({ msg: `Error: Image should be .PNG`, reason: 'error' });
                    }
                    setOpenSnackBar(true);
                    setIsSaving(false);
                });
            } else {
                setErrorMsg({ msg: `Image should be 284 x 284 px`, reason: 'warning' });
                setOpenSnackBar(true);
            }
            setIsSaving(false);
        };
        image.onerror = () => {
            setErrorMsg({ msg: `Error loading image`, reason: 'error' });
            setOpenSnackBar(true);
            setIsSaving(false);
        };
        image.src = URL.createObjectURL(file);
    };

    const { getInputProps, open } = useDropzone({
        noClick: true,
        noKeyboard: true,
        onDrop,
        accept: {
            'image/png': ['.png'],
            'image/svg+xml': ['.svg']
        },
        maxFiles: 1,
        maxSize: 2097152, // 2MB
    });

    return (
        <Button className='button' onClick={open} disabled={isSaving} fullWidth>
            <input hidden {...getInputProps()} />
            {isSaving ? <FaHourglassHalf id="bannerBtnIcon" fontSize="large" /> : 'Upload'}
        </Button>
    );
}

export default AvatarUpload;
